import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from '../_models';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthGuardSpecial implements CanActivate {

    currentUser = {} as User;
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {        
        this.router.navigate(['/home']);
        return true;
    }
}
